export default "__VITE_ASSET__2e1e7b15__"